import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyBlock = () => (
  <Box
    height="full"
    flexDirection="column"
    gap="s8"
    width="full"
    padding="s24"
    alignItems="center"
    textAlign="center"
  >
    <Icon.Large icon="file" color="grey600" />
    <Text.Header2>{i18n.t('finance.sale_invoices.detail.documents_empty.header')}</Text.Header2>
    <Text.Normal color="grey800">
      {i18n.t('finance.sale_invoices.detail.documents_empty.description')}
    </Text.Normal>
  </Box>
)
